<section class="searchbar-header__section">
  <div class="searchbar-header__wrapper">
    <div class="searchbar-header__container">
      <div class="searchbar-header__text">
        @if (title && isFirstSection) {
          <h1
            class="searchbar-header__text__title"
            [innerHTML]="title | unescape"
          ></h1>
        }
        @if (title && !isFirstSection) {
          <h2
            class="searchbar-header__text__title"
            [innerHTML]="title | unescape"
          ></h2>
        }
        @if (!title && description && isFirstSection) {
          <h1
            class="searchbar-header__text__description"
            [innerHTML]="description | unescape"
          ></h1>
        } @else {
          @if (description) {
            <h3
              class="searchbar-header__text__description"
              [innerHTML]="description | unescape"
            ></h3>
          }
        }
      </div>
      @if (!authService.isTeacher() || !authService.isSignedIn()) {
        <div
          class="button search-cta"
          (click)="searchService.openOrNavigateToSearch()"
          translate
        >
          texts.Search-Header-Find-Tutor-CTA
        </div>
      }
    </div>
  </div>
</section>
<div #breakpoint></div>
@if (showStorybrandSteps) {
  <app-storybrand-steps></app-storybrand-steps>
}
@if (showLogoGroup) {
  <app-logo-group [showGoogle]="showGoogleReviews"></app-logo-group>
}
@if (showEmpathy) {
  <app-empathy-statement
    [showLogoGroup]="showLogoGroup"
  ></app-empathy-statement>
}
